import { Injectable } from "@angular/core";
import { ApiStore, Storage } from "sync-engine";

@Injectable()
export class MemoryStorageService extends Storage {
  
  private _apiStorage = new Map<string, any>();
  private _apiCollections = new Map<string, Set<string>>();

  reset() {
    this._apiCollections = new Map();
    this._apiStorage = new Map<string, Set<string>>();
  }

  setStore<Data>(store: ApiStore<Data>, collection: string): boolean {
    try {
      this._apiStorage.set(store.apiStructure, store);
      if (collection) {
        if (!this._apiCollections.has(collection)) {
          this._apiCollections.set(collection, new Set());
        }
        const apiNameSet = this._apiCollections.get(collection);
        apiNameSet.add(store.apiStructure);
        this._apiCollections.set(collection, apiNameSet);
      }
      return true;
    } catch {
      return false;
    }
  }
  getStore<Data>(key: string): ApiStore<Data> {
    return this._apiStorage.get(key);
  }
  deleteStore<Data>(key: string): ApiStore<Data> {
    const store = this.getStore<Data>(key);
    if (store) {
      this._apiStorage.delete(key);
    }
    return store;
  }
  get Collections(): Map<string, Set<string>> {
    return this._apiCollections;
  }
}